import {API_PATH, HTTP_OK} from '@app/common/constants';
import {NetworkService, ToasterService} from '@app/services';
import {ToastType} from '@app/services/toaster';
import {takeLatest, call, put, select} from 'redux-saga/effects';
import {aiSummaryExpenseReducer} from './selectors';
import {
  aiSummaryExpenseStateActions,
  fetchCategoryForAISummaryExpenseCreatorTypeName,
  fetchAISummaryExpenseCreatorTypeName,
  fetchHqForAISummaryExpenseCreatorTypeName,
} from './slice';


/**
 * Generate AISummary HQ Watcher
 */
export function* fetchHQDropdownForAISummaryExpenseWatcher() {
  yield takeLatest(
    fetchHqForAISummaryExpenseCreatorTypeName,
    fetchHQDropdownForAISummaryExpenseWatcherWorker,
  );
}



/**
 * Generate AISummary  Watcher
 */
export function* fetchAISummaryExpenseWatcher() {
  yield takeLatest(
    fetchAISummaryExpenseCreatorTypeName,
    fetchAISummaryExpenseWatcherWorker,
  );
}

/**
 * Generate AISummary Category Watcher
 */
export function* fetchCategoryDropdownForAISummaryExpenseWatcher() {
  yield takeLatest(
    fetchCategoryForAISummaryExpenseCreatorTypeName,
    fetchCategoryDropdownForAISummaryExpenseWatcherWorker,
  );
}


/**
 * AI Summary Expense Worker
 */
export function* fetchAISummaryExpenseWatcherWorker(action : any): any {
  try {
    const url = `${API_PATH.ai_summary.ai_summary}`;
    yield put(
      aiSummaryExpenseStateActions.setShowLoader(true),
    );
    const aiSummaryResponse = yield call(
      NetworkService.postAgenticExpense,
      url,
      action.payload,
      {},
    );
    yield put(
      aiSummaryExpenseStateActions.setAISummaryExpenseData(aiSummaryResponse?.data),
    );
  } catch (error) {
  } finally {
    yield put(
      aiSummaryExpenseStateActions.setShowLoader(false),
    );
  }
}

/**
 * AI Summary Expense HQ Worker
 */
export function* fetchHQDropdownForAISummaryExpenseWatcherWorker(action : any): any {
  try {
    // const url = `${API_PATH.expenseDATAMaster.hqlistbydivisiondesignations}acka`;
    const url = `${API_PATH.inventoryModule.cnfHeadquarters}`;
    
    const HQDropdown = yield call(
      NetworkService.post,
      url,
      action.payload,
      {},
    );

    yield put(
      aiSummaryExpenseStateActions.setHQAISummaryExpenseData(HQDropdown.data),
    );
  } catch (error) {}
}

/**
 * AI Summary Expense Category Worker
 */
export function* fetchCategoryDropdownForAISummaryExpenseWatcherWorker(): any {
  try {
    const url = `${API_PATH.ai_summary.category}`;

    const categoryDropdown = yield call(NetworkService.getAgenticExpense, url, {}, {});

    // Transform the API response from array of strings to array of objects with label and value
    const transformedData = (categoryDropdown?.data || []).map((category: string) => ({
      label: category,
      value: category,
      displayName: category,
      categoryName: category,
      name: category,
    }));

    yield put(
      aiSummaryExpenseStateActions.setCategoryAISummaryExpenseData(
        transformedData,
      ),
    );
  } catch (error) {}
}
